import './Header.css';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/design/logo2.png';
import { useState, useEffect } from 'react';
import {
  getCurrentUser,
  isAuthed,
  logout,
  isSeller,
  isBuyer,
  isEventHost,
  refresh,
  isAdmin
} from '../../services/auth.service';
import { hRefreshToken, addSellerRole, getMessageUnreadCount, getUserActivity, getPublicCategories, getUserAvailablePoints } from '../../utils/api';
import { FaCaretDown, FaChartLine, FaLink, FaSlidersH, FaTicketAlt, FaTimes, FaUsers, FaUsersCog } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import {
  FaRegBell,
  FaBars
} from 'react-icons/fa';
import ManageRoles from '../manageroles/ManageRoles';
import iconSoftware from '../../assets/design/header/icon_platform_software.png';
import iconEvents from '../../assets/design/header/icon_platform_events.png';
import iconVendor from '../../assets/design/header/icon_platform_vendor.png';
import iconContent from '../../assets/design/header/icon_platform_content.png';
import iconCoin from '../../assets/rewards/lp-coin.png';
import { Coins, Rocket, Ticket } from 'lucide-react';
import { Mail, Settings, Bell, LogOut, Smartphone, Users, ChartLine, MessageCircle } from 'lucide-react';

function Header({ authenticated, availablePoints }) {
  const [authed, setAuthed] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [showMenu, setShowMenu] = useState(false);
  const [showAddSeller, setShowAddSeller] = useState(false);
  const [showActivity, setShowActivity] = useState(false);
  const [hamburgerClicked, setHamburgerClicked] = useState(false);
  const [userActivity, setUserActivity] = useState([]);
  const [unreadCount, setUnreadCount] = useState('0');
  const [showRoles, setShowRoles] = useState();
  const [categories, setCategories] = useState([]);
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [showPlatformDropdown, setShowDropdownPlatform] = useState(false);
  const [showDashboardDropdown, setShowDashboardDropdown] = useState(false);
  const [showCommunityDropdown, setShowCommunityDropdown] = useState(false);
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  let navigate = useNavigate();

  useEffect(() => {
    let user = getCurrentUser();

    if (user != null) {
      setAuthed(true);
      setCurrentUser(user);
    } else setAuthed(false);
  }, [authenticated]);

  async function handleLogout() {
    logout();
    setAuthed(false);
    setShowMenu(false);
    navigate('/', { replace: true });
  }

  async function loadCategories(){
    let res = await getPublicCategories();

    if (res.success){
      setCategories(res.data.slice(0, 10));
      setCategoriesLoaded(true);
    }
  }

  async function loadUnread(){
    let res = await getMessageUnreadCount();

    if (res.success){
      setUnreadCount(res.data);
    }
  }

  // force build
  function handleBurgerClick() {
    setHamburgerClicked(!hamburgerClicked);
    setShowModal(true);
    setShowMenu(!showMenu);
  }

  async function handleAddSeller() {
    setShowAddSeller(false);
    let res = await addSellerRole();

    if (res.success) {
      await hRefreshToken();
      window.location = '/dashboard/performance';
    }

    else if (res.status === 403){
      await refresh();

      let res = await addSellerRole();

      if (res.success) {
        await hRefreshToken();
        window.location = '/dashboard/seller';
      }
    }
  }

  async function toggleActivity(){
    setShowActivity(!showActivity);
    setShowModal(false);
  }

  async function handleLoadPoints(){

  }

    const handleRoleSwitch = (role) => {
    localStorage.setItem('activeRole', role);

    if (role === 'buyer') {
      window.location = '/dashboard/buyer';
    }

    if (role === 'seller') {
      window.location = '/dashboard/performance';
    }
  };

  useEffect(() => {
    loadUnread();
    loadCategories();
    handleLoadPoints();
  }, []);

  useEffect(async () => {
    if (showActivity === true){
      let res = await getUserActivity();

      if (res.success){
        setUserActivity(res.data);
      }
    }
  }, [showActivity]);

  return (
    <>
      <div className='header'>
        <div className='header__left'>
          <div className='header__logo'>
            <a href='/'>
              <img src={logo} alt='leadrpro logo' />
            </a>
          </div>

          <div className='header__menu-items'>
            <div>
              <Link to={'/software'} className='header__menu-item-link'>Software Directory</Link>
            </div>

            <div>
              <a href='javascript:void(0)' onClick={() => {setShowCategories(!showCategories);
                setShowDropdownPlatform(false);
                setShowDashboardDropdown(false);
                setShowCommunityDropdown(false);
              }
              }>Categories <FaCaretDown /></a>

              {categoriesLoaded && showCategories && (
              <div className='header__dropdown'>
                {categories.map((c, index) => (
                  <div key={index} className='header__category'>
                    <a href={`/category/${c.slug}`}>{c.name}</a>
                  </div>
                ))}

                <div className='header__category' onClick={() => setShowCategories(false)}>
                  <a href='/software'>View all software</a>
                </div>
              </div>
              )}
            </div>

            <div>
              <a href='javascript:void(0)' onClick={() => {
                setShowDropdownPlatform(!showPlatformDropdown);
              setShowCategories(false);
            setShowDashboardDropdown(false);
          setShowCommunityDropdown(false);
        }
              }>Platform <FaCaretDown /></a>

              {showPlatformDropdown && (
              <div className='header__dropdown'>
                <div className='header__dropdown-label'>
                  Explore our LeadrPro platform
                </div>

                <div className='header__dropdown-menu-items'>
                  <div className='header__dropdown-menu-item' onClick={() => {
                    navigate('/software-hub');
                    setShowDropdownPlatform(false);
                  }}>
                    <div className='header__dropdown-menu-item-icon'>
                      <img src={iconSoftware} alt='' />
                    </div>

                    <div className='header__dropdown-menu-item-info'>
                      <div className='header__dropdown-menu-item-info-name'>Software Hub</div>
                      <div className='header__dropdown-menu-item-info-description'>
                        Discover new and innovative solutions
                      </div>
                    </div>
                  </div>

                  <div className='header__dropdown-menu-item' onClick={() => {
                    navigate('/events-hub');
                    setShowDropdownPlatform(false);
                  }}>
                    <div className='header__dropdown-menu-item-icon'>
                      <img src={iconEvents} alt='' />
                    </div>

                    <div className='header__dropdown-menu-item-info'>
                      <div className='header__dropdown-menu-item-info-name'>Events Hub</div>
                      <div className='header__dropdown-menu-item-info-description'>
                        Attend live or webinar events
                      </div>
                    </div>
                  </div>

                  <div className='header__dropdown-menu-item' onClick={() => {
                    navigate('/vendor-hub');
                    setShowDropdownPlatform(false)
                  }}>
                    <div className='header__dropdown-menu-item-icon'>
                      <img src={iconVendor} alt='' />
                    </div>

                    <div className='header__dropdown-menu-item-info'>
                      <div className='header__dropdown-menu-item-info-name'>Vendor Hub</div>
                      <div className='header__dropdown-menu-item-info-description'>
                      Sell your product on our platform for free
                      </div>
                    </div>
                  </div>

                 
                  <div className='header__dropdown-menu-item' onClick={() => {
                    navigate('/blog');
                    setShowDropdownPlatform(false);
                  }}>
                    <div className='header__dropdown-menu-item-icon'>
                      <img src={iconContent} alt='' />
                    </div>

                    <div className='header__dropdown-menu-item-info'>
                      <div className='header__dropdown-menu-item-info-name'>Content Hub</div>
                      <div className='header__dropdown-menu-item-info-description'>
                        Educational segments
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              )}
            </div>

            {authed && isSeller() && isBuyer() == false && (
              <div>
                <Link to='/dashboard/performance'>Dashboard</Link>
              </div>
            )}

            {authed && isBuyer() && isSeller() == false && (
              <div>
                <Link to='/dashboard/buyer'>Dashboard</Link>
              </div>
            )}

            {authed && isBuyer() && isSeller() == true && (
              <>
                <div>
                  <a href='javascript:void(0)' onClick={() => {setShowDashboardDropdown(!showDashboardDropdown);
                    setShowCategories(false);
                    setShowDropdownPlatform(false);
                    setShowCommunityDropdown(false);
                  }
                   } to='/dashboard/buyer'>Dashboards <FaCaretDown /></a>

{showDashboardDropdown && (
                <div className='header__dropdown'>
                  <div className='header__dropdown-label'>
                    Available dashboards
                  </div>

                  <div className='header__dropdown-menu-items'>
                    <div className='header__dropdown-menu-item' onClick={() => {
                      handleRoleSwitch('buyer');
                    }}>


                      <div className='header__dropdown-menu-item-info'>
                        <div className='header__dropdown-menu-item-info-name'>Buyer Dashboard</div>
                        <div className='header__dropdown-menu-item-info-description'>
                          Discover new and innovative solutions
                        </div>
                      </div>
                    </div>

                    <div className='header__dropdown-menu-item' onClick={() => {
                      handleRoleSwitch('seller');
                      setShowDashboardDropdown(false);
                    }}>


                      <div className='header__dropdown-menu-item-info'>
                        <div className='header__dropdown-menu-item-info-name'>Seller Dashboard</div>
                        <div className='header__dropdown-menu-item-info-description'>
                          Manage your upcoming demos and team.
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                )}
                </div>
              </>
            )}

            <div>
              <a href='/deals'>
                <Ticket className='w-4 h-4' /> Deals
              </a>
            </div>

            <div>
              <a href='/launch/home'>
                <Rocket className='w-4 h-4' /> Weekly Launch
              </a>
            </div>

            {/* <div>
              <a href='javascript:void(0)' onClick={() => {
                setShowCommunityDropdown(!showCommunityDropdown);
                setShowCategories(false);
                setShowDropdownPlatform(false);
                setShowDashboardDropdown(false);
              }
                } to='/dashboard/buyer'>Community <FaCaretDown /></a>

{showCommunityDropdown && (
              <>
                <div className='header__dropdown'>
                  <div className='header__dropdown-label'>
                    Community events
                  </div>

                  <div className='header__dropdown-menu-items'>
                    <div className='header__dropdown-menu-item' onClick={() => {
                      navigate('/events');
                      setShowCommunityDropdown(false);
                    }}>
                      <div className='header__dropdown-menu-item-icon'>
                        <img src={iconEvents} alt='' />
                      </div>

                      <div className='header__dropdown-menu-item-info'>
                        <div className='header__dropdown-menu-item-info-name'>Roundtable Events</div>
                        <div className='header__dropdown-menu-item-info-description'>
                          Register for exclusive in-person events
                        </div>
                      </div>
                    </div>

                    <div className='header__dropdown-menu-item' onClick={() => {
                      navigate('/webinars');
                      setShowCommunityDropdown(false);
                    }}>
                      <div className='header__dropdown-menu-item-icon'>
                        <img src={iconContent} alt='' />
                      </div>

                      <div className='header__dropdown-menu-item-info'>
                        <div className='header__dropdown-menu-item-info-name'>Online Webinars</div>
                        <div className='header__dropdown-menu-item-info-description'>
                          Register for exclusive online webinars
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
              </>
            )}
            </div> */}

            {/* {authed === false && (
              <div>
                <Link onClick={() => {
                  setShowCommunityDropdown(false)
                }} to='/vendor-hub#pricing'>Pricing</Link>
              </div>
            )} */}

            {/* <div>
              <Link to='/events'>Events</Link>
            </div>

            <div>
              <Link to='/webinars'>Webinars</Link>
            </div> */}
          </div>
        </div>

        <div className='header__right'>
          {authed === false && (
            <div className='header__account-btns'>
              <Link to='/login' onClick={() => setShowMenu(false)} variant="ghost" className="text-gray-600 hover:text-purple-600">
                Sign In
              </Link>

              <Link className='header__account-btn header__account-btn--primary ml-4' to='/join-now'>
                Sign up
              </Link>
            </div>
          )}

          {authed && (
            <div className='header__logged-in'>
              {isBuyer() && (
                <Link to={'/dashboard/redeem'} className='header__point-count'>
                  <span>
                    <img src={iconCoin} alt='' style={{height: '24px'}} height={50} />
                  </span>

                  <span className='ml-10'>
                    {availablePoints}
                  </span>
                </Link>
              )}

              <div className='pointer' onClick={() => toggleActivity()}>
                <FaRegBell />
              </div>

              {showActivity && (
                <>
                  <div className={`header__modal-activity header__modal${showActivity ? ' show' : ''}`}>
                    <div className='header__activity-header'>Recent Activity</div>

                    {userActivity && userActivity.length == 0 && (
                      <div style={{padding: '20px', fontSize: '12px'}} className='center'><i>No recent activity found...</i></div>
                    )}
                    {userActivity.map((x, index) => (
                      <div key={index} className='header__activity-item'>
                        <div className='header__activity-item-date'>{new Date(x.date_created).toLocaleString()}</div>
                        <div className='header__activity-item-text'>{x.display_text}</div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              <div className='header__profile' onClick={() => setShowMenu(!showMenu)}>
                <div className='header__profile-image'>
                  <img src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + currentUser.logo}
                  />
                </div>

                <div className='header__profile-info'>
                  <div className='header__profile-name'>
                    {currentUser.first_name}
                  </div>
                  <div className='header__company-name'>
                    {currentUser.company_name}
                  </div>
                </div>

                <div className='header__expand'>
                  <FaCaretDown />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className={ hamburgerClicked ? 'header__hamburger active' : 'header__hamburger'} onClick={() => handleBurgerClick()}>
          <FaBars />
        </div>
      </div>

      {showMenu && (
        <div className={`header__modal`}>
          <div className='header__modal-section'>
            {authed === false && (
              <div className=''>
                <div className='header__mobile-links'>
                  <div className='header__modal-link'>
                    <a href='/sellers'>Become A Seller</a>
                  </div>

                  <div className='header__modal-link'>
                    <a href='/pricing'>Pricing</a>
                  </div>
                  <div className='header__modal-link'>
                    <a href='/how-it-works'>How It Works</a>
                  </div>
                </div>
              </div>
            )}

            {authed && isSeller() && (
              <div className='header__modal-link'>
                <a href='javascript:void(0)' onClick={() => handleRoleSwitch('seller')}>
                  <span className='header__modal-link-icon'><ChartLine className="w-5 h-5" /></span>
                  <span>Seller Dashboard</span>
                </a>
              </div>
            )}

            {authed && isBuyer() && isSeller() == false && (
              <div className='header__modal-link'>
                <a href='javascript:void(0)' onClick={() => handleRoleSwitch('buyer')}>
                  <span className='header__modal-link-icon'><MessageCircle className="w-5 h-5" /></span>
                  <span>Dashboard</span>
                </a>
              </div>
            )}

            {authed && isBuyer() && isSeller() == true && (
              <div className='header__modal-link'>
                <a href='javascript:void(0)' onClick={() => handleRoleSwitch('buyer')}>
                  <span className='header__modal-link-icon'><MessageCircle className="w-5 h-5" /></span>
                  <span>Buyer Dashboard</span>
                </a>
              </div>
            )}

            {authed && (isBuyer() || isSeller()) && (
              <div className='header__modal-link'>
                <Link to='/dashboard/inbox' style={{justifyContent: 'space-between'}} onClick={() => setShowMenu(false)}>
                  <span style={{marginLeft: '0px'}}>
                    <span className='header__modal-link-icon'>
                      <Mail className="w-5 h-5" />
                    </span>
                    <span>Inbox</span>
                  </span> 

                  {unreadCount != 0 && (
                    <span className='header__unread-badge'>New</span>
                  )}
                </Link>
              </div>
            )}

            {authed && (
              <div className='header__modal-link'>
                <Link to='/account/home' onClick={() => setShowMenu(false)}>
                  <span className='header__modal-link-icon'>
                    <Settings className="w-5 h-5" />
                  </span>
                  <span>Settings</span>
                </Link>
              </div>
            )}

            <div className='header__modal-link'>
              <Link to='/app' onClick={() => setShowMenu(false)}>
                <span className='header__modal-link-icon'><Smartphone className="w-5 h-5" /></span>
                <span>Get the App</span>
              </Link>
            </div>

            <div className='header__modal-link'>
              <a href='javascript:void(0)' onClick={() => {
                setShowRoles(true);
                setShowMenu(false);
              }}>
                <span><Users className="w-5 h-5" /></span>
                <span>Manage Roles</span>
              </a>
            </div>

            {authed && (
              <div className='header__log-out'>
                <div className='header__btn-logout' onClick={handleLogout}>
                  <span><LogOut className="w-5 h-5 text-red-500" /></span>
                  <span className='ml-10' style={{marginTop: '-5px'}}>Log out</span>
                </div>
              </div>
            )}

            {authed === false && (
              <div className='header__menu-account-btns flex align-center gap-4'>
                <Link onClick={() => setShowMenu(false)} className='header__account-btn' to='/login'>
                  Login
                </Link>

                <Link onClick={() => setShowMenu(false)} className='header__account-btn header__account-btn--primary ml-4' to='/signup'>
                  Sign up
                </Link>
              </div>
            )}
          </div>
        </div>
      )}

      {showAddSeller && (
        <>
          <div className='overlay'></div>

          <div className='modal modal--wide'>
            <div className='modal__close' onClick={() => setShowAddSeller(false)}>
              <FaTimes />
            </div>

            <p className='modal__h2'>
              Add your company to our solutions directory for FREE
            </p>

            <p className='mt-20'>
              <img src='https://ik.imagekit.io/ivgrhmd4k/Screenshot_2023-04-23_193143.png?updatedAt=1682303817301' />
            </p>

            <p className='mt-20'>
              <h3>Benefits:</h3>

              <ul style={{ listStyleType: 'disc' }}>
                <li>Free company public listing</li>

                <li>
                  Search 1000's of prospects matching your ideal candidate
                  profile
                </li>

                <li>
                  Get real interested candidates looking for solutions just like yours
                </li>
              </ul>
            </p>

            <p className='mt-30 center'>
              <button className='btn btn--primary' onClick={() => handleAddSeller()}>
                Get Started
              </button>
            </p>
          </div>
        </>
      )}

      {showRoles && (
          <div className='header__manage-roles'>
            <ManageRoles />

            <div className='center'>
              <button className='btn' onClick={() => setShowRoles(false)}>Back</button>
            </div>
          </div>
      )}
    </>
  );
}

export default Header;
